import React from 'react';
import { CustomBackdrop, Header, NavHeader, Page, SubmitButton } from '../../../../../../../components';
import { ChannelBoxIcon } from '../../../../../components/channel/box-icon';
import { useCalibration } from '../../common/hooks/use-calibration';
import './index.scss';

const Srp22CalibrationSuccess: React.FC = () => {
  const { channel, navigate, t } = useCalibration();

  const handleClick = () => navigate(-5);

  return (
    <Page
      className="calibration-flow"
      isStickyHeader
      whiteContent
      header={
        <>
          <NavHeader />
          <Header title={t('exalus.calibration')} />
        </>
      }
    >
      {channel && <ChannelBoxIcon channel={channel} className="blind-icon" />}
      <p className="channel-name">{channel?.Name}</p>
      <p className="info m-t-40">{t('exalus.params.SrpParams.calibrationFlow.calibrationSuccess')}</p>

      <SubmitButton type="button" onClick={handleClick} tranparent>
        OK
      </SubmitButton>
      {!channel && <CustomBackdrop loading />}
    </Page>
  );
};

export default Srp22CalibrationSuccess;
